<div *ngIf="isValid$ | async; else invalidForm" #container>
  <div
    *ngIf="attendanceDataObs | async as attendanceData; else loader"
    class="mx-auto py-2"
    style="max-width: 1200px; width: 100%; padding: 1rem"
  >
    <div class="card mb-2">
      <div class="card-body">
        <div class="card-title">
          {{ attendanceData.scheduleTitle }}
        </div>
      </div>
    </div>

    <!-- External sheet: no user session, so the Family endpoints can't answer —
         the family filter is explicitly off (no anonymous request is fired). -->
    <attendance-contact-list
      [pageData]="pageData"
      [contactDetail]="attendanceContactDetail"
      [showFamilyFilter]="false"
    ></attendance-contact-list>

    <detail-info-form-page-steps
      *ngIf="attendanceData.groupInfos"
      [showReset]="false"
      (formSubmit)="$event ? onFormSubmit($event) : null"
      [detailGroupInfoList]="attendanceData.groupInfos"
      [processing$]="processing$"
      [showCancel]="false"
      [variants]="formLevelVariants"
      [selectedVariantGuid]="formLevelSelectedVariantGuid"
      (variantChange)="onFormLevelVariantChange($event)"
    >
      <div class="mb-1" recaptcha>
        <div class="g-recaptcha">
          <ng-container *ngIf="captchaSiteKeyObs | async as captchaSiteKey">
            <re-captcha
              name="recaptcha"
              required
              [siteKey]="captchaSiteKey"
              (resolved)="recaptchaResolved($event)"
            >
            </re-captcha>
          </ng-container>
        </div>
      </div>
    </detail-info-form-page-steps>
  </div>
</div>
<ng-template #invalidForm>
  <h2 class="p-2 text-center">Something is wrong. Try again.</h2>
</ng-template>
<ng-template #loader>
  <app-loader></app-loader>
</ng-template>
